import { actions } from '../constants/document';
import * as actionTypes from '../../models/action/document';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';

const _logger = Log.create('Document Add Page');
// #region Add Document Action
export function addDocumentGetAction(data: actionTypes.IDocumentData, spinnerId?: string, spinnerType?: 'get'|'set', callback?: (value: boolean) => void): actionTypes.IGetAddDocument {
    return {
        DocumentData: data,
        timestamp: Date.now(),
        type: actions.ADD_DOCUMENT_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

// Add Document Update Get Action
export function updateDocumentGetAction(
    dataParams: actionTypes.IDocumentParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateDocumentGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_DOCUMENT_UPDATE_ACTIVITY
    };
}

export function setDocumentDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_DOCUMENT_DATA_DEFAULT
    };
}

export function addDocumentSetAction(
    DocumentData: actionTypes.IDocumentData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddDocument {
    return {
        DocumentData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_DOCUMENT_SET_ACTIVITY
    };
}
// #endregion Add Document Action

// #region Add Document Action
export function deleteDocumentGetAction(data: actionTypes.IDeleteData): actionTypes.IGetDeleteDocument {
    return {
        DocumentData: data,
        timestamp: Date.now(),
        type: actions.DELETE_DOCUMENT_ACTIVITY
    };
}

export function deleteDocumentSetAction(deleteDocumentStatus: boolean): actionTypes.ISetDeleteDocument {
    return {
        deleteDocumentStatus,
        timestamp: Date.now(),
        type: actions.DELETE_DOCUMENT_SET_ACTIVITY
    };
}
// #endregion Add Document Action

//#region Document Pdf Page
export function saveDocumentPdfPage(
    courseId: string,
    activityId: string,
    fileId: string,
    page: number,
    totalPage: number,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        courseId,
        activityId,
        page,
        totalPage,
        fileId,
        reset,
        timestamp: Date.now(),
        type: actions.SET_DOCUMENT_ACTIVITY_PDF_PAGE,
        spinnerId,
        spinnerType
    };
}
